import { useEffect, useCallback } from 'react';
/* globals google */

export default function useGoogleMap({ initialize, options, getElement }) {
  const getElementCallback = useCallback(getElement, []);

  const renderMap = useCallback(() => {
    const element = getElementCallback();
    if (element) {
      initialize(new google.maps.Map(element, options(google)), google);
    }
  }, [options, initialize, getElementCallback]);

  useEffect(() => {
    const googleMapsScript = document.getElementById('googleMaps');

    if (googleMapsScript) {
      if (window.google) renderMap();
      return;
    }

    (function (d, script) {
      script = d.createElement('script');
      script.setAttribute('id', 'googleMaps');
      script.type = 'text/javascript';
      script.async = true;
      script.onload = function () {
        renderMap();
      };

      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
      d.getElementsByTagName('body')[0].appendChild(script);
    })(document);
  }, [renderMap]);
}
